import(/* webpackMode: "eager" */ "/home/runner/_work/nvs-code/nvs-code/common/temp/node_modules/.pnpm/next@14.2.4_2mygebwfgdyopr3fy2qddu2eli/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["BaseLayout"] */ "/home/runner/_work/nvs-code/nvs-code/web/app/components/BaseLayout.tsx");
